








































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import ChangePasswordModal from '@/components/modals/ChangePasswordModal.vue';

const namespace: string = 'authentication';

@Component({
  components: {
    ChangePasswordModal,
  },
})
export default class App extends Vue {
  @Getter('user', { namespace }) userData!: any;
  @Action('getUserData', { namespace }) getUserData!: any;
  @Action('updatePassword', { namespace }) updatePassword!: any;
  @Action('logout', { namespace }) logoutAction!: any;

  remindersSearch: string = '';

  mounted() {
    this.getUserData();
  }

  logout() {
    this.logoutAction();
  }

  get user() {
    return this.userData;
  }

  openChangePasswordModal() {
    ((this.$refs.changePasswordModalRef) as any).showModal();
  }

  openCreateUserModal() {
    ((this.$refs.createUserModalRef) as any).showModal();
  }

  savePassword(data: Comment) {
      this.updatePassword({
          data,
      });
  }
}
